// extracted by mini-css-extract-plugin
export default {"link":"HeaderButton_link__wIYAf","button":"HeaderButton_button__I9XIh","primary":"HeaderButton_primary__g9RGv","secondary":"HeaderButton_secondary__h0Coe"};